export const BIG_FILE_BYTES = 50 * 1024 * 1024; // 50 MB
// Phone-publish has legitimately quiet periods (Appium session init ~12s,
// account switch ~15s, on-device compose ~35s) with no SSE event, so a 15s
// threshold false-fired the "stalled" banner. 45s still catches a genuinely
// stuck upload while tolerating the on-device flow.
export const STALL_MS = 45_000;

// Rough upload-time estimate by size. Assumes a conservative ~1 MB/s mobile
// uplink, bucketed so the copy reads naturally.
function estimateMinutes(bytes: number): number {
  const mb = bytes / (1024 * 1024);
  return Math.max(1, Math.round(mb / 60)); // ~1 MB/s ≈ 60 MB/min
}

export function bigFileWarning(bytes: number): string | null {
  if (!Number.isFinite(bytes) || bytes <= 0 || bytes < BIG_FILE_BYTES) return null;
  const mb = Math.round(bytes / (1024 * 1024));
  const min = estimateMinutes(bytes);
  return `Видео большое (${mb} МБ). Не сворачивайте вкладку и не блокируйте экран до конца загрузки. На слабой сети это займёт ~${min} мин.`;
}

export function isStalled(lastProgressTs: number, now: number, thresholdMs: number = STALL_MS): boolean {
  return now - lastProgressTs >= thresholdMs;
}
